import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CurvaAbcVendaReferencia, referencias } from '../curva-abc-venda-referencia';


@Component({
    selector: 'sgt-curva-abc-venda-referencia-select',
    templateUrl: './curva-abc-venda-referencia-select.component.html',
    styleUrls: ['./curva-abc-venda-referencia-select.component.less']
})
export class CurvaAbcVendaSelectComponent implements OnInit {
    referenciasOptions: CurvaAbcVendaReferencia[] = [];

    /** Referência selecionada */
    @Input() referencia: CurvaAbcVendaReferencia;
    /** Referência alterada */
    @Output() referenciaChange = new EventEmitter<CurvaAbcVendaReferencia>();
    /** ID da referência */
    @Input() idReferencia: number;
    /** Ao alterar o ID da referência */
    @Output() idReferenciaChange = new EventEmitter<number>();

    /** Se deve exibir o title do select */
    @Input() isShowTitle = false;
    /** Se deve exibir a opção de selecionar a opção nula */
    @Input() isShowNull = true;
    /** Label para a opção de selecionar a opção nula */
    @Input() nullLabel = 'Nenhuma referência'
    /** Label para a opção nula quando estiver selecionada */
    @Input() nullLabelSelected = 'Nenhuma referência'
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;

    /** Após iniciar o select */
    @Output() afterInitialized = new EventEmitter<void>();

    /** Após selecionar a referência */
    @Output() afterSelect = new EventEmitter<void>();

    async ngOnInit(): Promise<void> {
        await this.create();
        setTimeout(() => this.afterInitialized.emit(), 0);
    }

    /** Cria as referências para o select */
    private create(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.referenciasOptions = referencias;

            setTimeout(() => {
                if (this.idReferencia) { // Se for informado um ID de referência, obtemos e selecionamos ela
                    const referencia = this.referenciasOptions.find(referenciaFilter => referenciaFilter.id === this.idReferencia);
                    this.select(referencia);
                } else if (!this.isShowNull) {  // Se não, selecionamos a primeira referência
                    this.select(this.referenciasOptions[0]);
                }

                resolve();
            }, 200);
        });
    }

    /** Ao selecionar a referência */
    select(referencia: CurvaAbcVendaReferencia) {
        this.idReferencia = referencia ? referencia.id : null;
        this.idReferenciaChange.emit(this.idReferencia);
        this.referencia = referencia;
        this.referenciaChange.emit(this.referencia);

        this.afterSelect.emit();
    }
}
